import { createApplication, IAppApplication } from '@/app/application'
import { IAppContext } from '@/app/context'
import { installGlobalProperties } from '@/app/globals'
import { installVuePlugins, registerGlobalComponents } from '@/app/plugins'
import { mountRootApp } from '@/app/instance'
import { getRootComponent } from '@/app/root'

export type AppFramework = IAppApplication

let appFramework: AppFramework | null = null

export function getAppFramework(): AppFramework {
  if (!appFramework) {
    appFramework = createApplication(getRootComponent(), mountRootApp)
  }

  return appFramework
}

export function configureAppFramework(framework: AppFramework, context: IAppContext): void {
  framework.config.productionTip = false
  framework.setIntegration('router', context.router)
  framework.setIntegration('store', context.store)

  registerGlobalComponents(framework)
  installVuePlugins(framework, context.store)
  installGlobalProperties(framework)
}
